export const chainConstants = {
    CHAIN: "CHAIN",
  };
  